module.exports = __webpack_public_path__ + "static/img/empty.bb83729d.png";